import { Viewport, onListItemHref } from 'Common/utils';

export default class SlideNavigationController {
    static init({ originalActiveLink = -1, numLinks = 0 } = {}) {
        const ctrl = new this(originalActiveLink, numLinks);
        let lastMobile = ctrl.isMobile;

        const userMenuBtn = document.getElementById('userMenu');

        if (userMenuBtn && window.bootstrap?.Dropdown) {
            new window.bootstrap.Dropdown(userMenuBtn);
        }

        // stopPropagation on open button & nav container
        const btnNavOpen = document.getElementById('btn-nav-open');
        const navContainer = document.getElementById('nav-container');

        btnNavOpen?.addEventListener('click', (e) => e.stopPropagation());
        navContainer?.addEventListener('click', (e) => e.stopPropagation());

        // open/close handlers
        btnNavOpen?.addEventListener('click', ctrl.openNav);
        document.getElementById('btn-nav-close')?.addEventListener('click', ctrl.closeNav);

        // per-link wiring
        for (let i = 0; i < ctrl.numLinks; i++) {
            const navItem = document.getElementById(`nav-item-${i}`);

            if (navItem) {
                if (!ctrl.isTouch) {
                    navItem.addEventListener('mouseover', ctrl.activator(i));
                }
                navItem.addEventListener('click', ctrl.activator(i));
            }

            // mobile links
            document
                .querySelectorAll('.mobile-nav-link[href]')
                .forEach((el) => el.addEventListener('click', () => el.classList.add('active')));

            document.getElementById(`mobile-nav-item-${i}`)?.addEventListener('click', ctrl.activator(i));
        }

        // hook list-item clicks
        document
            .querySelectorAll('.MenuCtaPromoBlock .link-list ul > li, .nav-childItem-list > li, .nav-childItem')
            .forEach((li) => li.addEventListener('click', onListItemHref));

        // child-item toggle
        document.querySelectorAll('.nav-childItem-head').forEach((headEl) => {
            headEl.addEventListener('click', (e) => {
                e.stopPropagation();
                const anchor = e.target.closest('a');

                if (!anchor) return;

                const allHeads = document.querySelectorAll('.nav-childItem-head');
                const allLists = document.querySelectorAll('.nav-childItem-list');

                const isOpen = anchor.classList.contains('showChild');

                // close everything first
                allHeads.forEach((a) => a.classList.remove('showChild'));
                allLists.forEach((list) => list.classList.remove('open'));

                if (!isOpen) {
                    // open this one
                    anchor.classList.add('showChild');
                    const li = anchor.closest('li');
                    const sublist = li?.querySelector('ul');

                    if (sublist) sublist.classList.add('open');
                }
            });
        });

        // viewport change handler
        Viewport.onChange(() => {
            const { isMobile } = ctrl;

            document.querySelectorAll('.nav-children').forEach((el) => {
                el.style.maxHeight = isMobile ? '0' : 'none';
            });
            if (isMobile !== lastMobile && ctrl.activeLink >= 0) {
                const listEl = document.getElementById(`nav-list-${ctrl.activeLink}`);

                if (listEl) {
                    const ul = listEl.querySelector('ul');

                    listEl.style.maxHeight = ul ? `${Math.ceil(ul.scrollHeight)}px` : '0';
                }
            }
            lastMobile = isMobile;
        });
    }

    activeLink = -1;
    originalActiveLink = -1;

    get isTouch() {
        return Viewport.viewport.is.touch;
    }
    get isMobile() {
        return Viewport.viewport.is.mobile;
    }

    setActive(index) {
        if (index === this.activeLink) return;

        // clear previous
        if (this.activeLink >= 0) {
            const prevLinkA = document.querySelector(`#nav-item-${this.activeLink} > a`);

            prevLinkA?.classList.remove('selected');

            document.getElementById(`navbar-cta-${this.activeLink}`)?.classList.add('d-none');

            const prevList = document.getElementById(`nav-list-${this.activeLink}`);

            if (prevList) {
                prevList.classList.remove('selected');
                prevList.style.maxHeight = this.isMobile ? '0' : 'none';
            }

            document.getElementById(`mobile-nav-item-${this.activeLink}`)?.classList.remove('selected');
        }

        // activate new
        if (index >= 0) {
            document.querySelector(`#nav-item-${index} > a`)?.classList.add('selected');
            document.getElementById(`navbar-cta-${index}`)?.classList.remove('d-none');

            const listEl = document.getElementById(`nav-list-${index}`);

            if (listEl) {
                listEl.classList.add('selected');
                const ul = listEl.querySelector('ul');

                listEl.style.maxHeight = this.isMobile && ul ? `${Math.ceil(ul.scrollHeight)}px` : 'none';
            }

            document.getElementById(`mobile-nav-item-${index}`)?.classList.add('selected');
        }

        this.activeLink = index;
    }

    constructor(originalActiveLink = -1, numLinks = 0) {
        this.originalActiveLink = originalActiveLink;
        this.numLinks = numLinks;
        this.setActive(originalActiveLink);
    }

    closeNav = () => {
        document.removeEventListener('click', this.closeNav);
        const navContainer = document.getElementById('nav-container');
        const btnNavOpen = document.getElementById('btn-nav-open');

        navContainer?.classList.replace('shown', 'hidden');
        btnNavOpen?.classList.remove('hidden');
        navContainer?.classList.remove('enabled');
        setTimeout(() => {
            this.setActive(this.originalActiveLink);
            navContainer?.classList.remove('enabled');
        }, 500);
    };

    openNav = () => {
        const navContainer = document.getElementById('nav-container');
        const btnNavOpen = document.getElementById('btn-nav-open');

        navContainer?.classList.add('shown');
        btnNavOpen?.classList.add('hidden');
        document.addEventListener('click', this.closeNav);
        setTimeout(() => navContainer?.classList.add('enabled'), 400);
    };

    activator = (i) => () => this.setActive(i);
}
